// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_LIVREURS = "GET_LIVREURS";

// Add LIVREUR
export const ADD_NEW_LIVREUR = "ADD_NEW_LIVREUR";
export const ADD_LIVREUR_SUCCESS = "ADD_LIVREUR_SUCCESS";
export const ADD_LIVREUR_FAIL = "ADD_LIVREUR_FAIL";

// Edit LIVREUR
export const UPDATE_LIVREUR = "UPDATE_LIVREUR";
export const UPDATE_LIVREUR_SUCCESS = "UPDATE_LIVREUR_SUCCESS";
export const UPDATE_LIVREUR_FAIL = "UPDATE_LIVREUR_FAIL";
